<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2" v-if="house">Casa: {{house.title}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/casas/nuevo">Nuevo</b-button>
                        <b-button variant="outline-primary" :to="'/casas/editar/' + this.$route.params.id">Editar
                        </b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <template v-else>
                <b-list-group v-if="1===2">
                    <b-list-group-item><b>ID:</b><span>{{house.id}}</span></b-list-group-item>
                    <b-list-group-item><b>Casa:</b><span>{{house.title}}</span></b-list-group-item>
                </b-list-group>

                <b-row>
                    <b-col md="12">
                        <br>
                        <h3 class="h4">Ficha técnica</h3>
                    </b-col>
                    <b-col md="6">
                        <b-list-group>
                            <b-list-group-item><b>Casa:</b><span>{{house.house}}</span></b-list-group-item>
                            <b-list-group-item><b>Cliente:</b><span><router-link
                                    :to="'/usuarios/' + house.client.value">{{house.client.label}}</router-link></span>
                            </b-list-group-item>
                            <b-list-group-item><b>Etapa:</b><span><router-link
                                    :to="'/etapas/' + house.stage.value">{{house.stage.label}}</router-link></span>
                            </b-list-group-item>
                            <b-list-group-item><b>Lote:</b><span><router-link :to="'/lotes/' + house.lot.value">{{house.lot.label}}</router-link></span>
                            </b-list-group-item>
                            <b-list-group-item><b>Dirección:</b><span>{{house.address}}</span></b-list-group-item>
                            <b-list-group-item><b>Fecha de entrega:</b><span>{{house.delivery_date | moment("DD/MM/YYYY")}}</span>
                            </b-list-group-item>
                            <b-list-group-item><b>Precio:</b><span>{{house.price_uf}} UF</span></b-list-group-item>
                            <b-list-group-item><b>Reserva:</b><span>{{house.booking_uf}} UF</span></b-list-group-item>
                            <b-list-group-item><b>Pie:</b><span>{{house.downpayment_uf}} UF</span></b-list-group-item>
                        </b-list-group>
                    </b-col>
                    <b-col md="6">
                        <b-list-group>
                            <b-list-group-item><b>Sitio:</b><span>{{house.place}}</span></b-list-group-item>
                            <b-list-group-item><b>Condominio:</b><span>{{house.condo}}</span></b-list-group-item>
                            <b-list-group-item><b>Modelo:</b><span>{{house.model}}</span></b-list-group-item>
                            <b-list-group-item><b>Baños:</b><span>{{house.bathrooms}}</span></b-list-group-item>
                            <b-list-group-item><b>Dormitorios:</b><span>{{house.bedrooms}}</span></b-list-group-item>
                            <b-list-group-item><b>Superficie
                                construida:</b><span>{{house.surface_house}} m<sup>2</sup></span>
                            </b-list-group-item>
                            <b-list-group-item><b>Superficie
                                terreno:</b><span>{{house.surface_terrain}} m<sup>2</sup></span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <br>
                        <h3 class="h4">Multimedia</h3>
                    </b-col>
                    <b-col md="6">
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe class="embed-responsive-item" :src="house.video" frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <b-table hover v-bind:items="house.images" v-bind:fields="imageHeaders" outlined
                                 head-variant="light">
                            <template slot="image" slot-scope="data">
                                <a :href="data.item.url" target="_blank"><img class="thumb" :src="data.item.url"/></a>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <br>
                        <h3 class="h4">Documentos</h3>
                    </b-col>
                    <b-col md="12">

                        <b-table hover v-bind:items="house.documents" v-bind:fields="documentHeaders"
                                 outlined
                                 head-variant="light">
                            <template slot="file" slot-scope="data">
                                <b-link v-bind:to="data.item.file.url" target="_blank">{{data.item.file.name}}</b-link>
                            </template>
                            <template slot="title" slot-scope="data">
                                {{data.item.title}}
                            </template>
                        </b-table>

                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <br>
                        <h3 class="h4">Tareas</h3>
                        <b-table hover v-bind:items="tasks" v-bind:fields="taskHeaders" outlined
                                 head-variant="light">
                            <template slot="finished" slot-scope="data">
                                <span v-html="(data.item.finished === true ) ? 'Finalizado' : 'En progreso'"></span>
                            </template>
                            <template slot="finish_date" slot-scope="data">
                                <span>{{data.item.finish_date | moment("DD/MM/YYYY")}}</span>
                            </template>
                            <template slot="attachments" slot-scope="data">
                                <a target="_blank" :href="data.item.attachments"
                                   v-if="data.item.attachments">Descargar</a>
                                <span v-else>Sin adjunto</span>
                            </template>
                            <template slot="comments" slot-scope="data">
                                <div v-html="data.item.comments"></div>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>

            </template>

        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "HousesView",
        data() {
            return {
                isLoading: true,
                taskHeaders: [
                    {key: 'title', label: 'Tarea', sortable: true},
                    {key: 'finished', label: 'Estado', sortable: true},
                    {key: 'finish_date', label: 'Fecha', sortable: true},
                    {key: 'attachments', label: 'Adjunto', sortable: true},
                    {key: 'comments', label: 'Comentarios', sortable: true},
                    // {key: 'actions', label: 'Acciones', sortable: false},
                ],
                documentHeaders: [
                    {key: 'title', label: 'Título', sortable: false},
                    {key: 'file', label: 'Archivo', sortable: false},
                ],
                imageHeaders: [
                    {key: 'image', label: 'Imagen', sortable: false},
                    {key: 'url', label: 'Ruta de archivo', sortable: true}
                ]
            }
        },
        computed: {
            ...mapGetters({
                house: 'houses/getEntries',
                tasks: 'stages/getTasks'
            })
        },
        created() {
            this.$store.dispatch('houses/loadEntries', this.$route.params.id).then(() => {
                this.$store.dispatch('stages/loadEntries', this.house.stage.value).then(() => {
                    this.isLoading = false;
                });
                // this.tasks(this.$route.params.id);
            });


        }
    }
</script>

<style scoped>
    .list-group-item > b {
        flex: 2;
    }

    .thumb {
        max-width: 128px;
    }
</style>